import "core-js/features/global-this";
import "../../../node_modules/node-waves/dist/waves.js";
import "../Content/ts/preloadLogin";
import "../Content/js/system/jquery.cookie.js";
import "../../../node_modules/bootstrap/dist/js/bootstrap.js";
import "../Content/js/material/functions.js";
import "../Content/ts/helper/helper";
import "../Content/ts/helper/Helper.Database";
import "../Content/ts/helper/Helper.User";
import "../Content/ts/helper/Helper.String";
import "../Content/ts/helper/Helper.Url";
import "../Content/ts/Crm.Token";
import "../Content/ts/Login";
